import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TPVService } from '@core/services/tpv.service';
import { InscriptionService } from '@core/use-case-services/inscription.service';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'gt-payment-type',
  templateUrl: './payment-type.component.html',
  styles: `
    .wallet-icon {
      width: 12rem;
      height: 12rem;
    }
    gt-button {
      width: 100%;
      --height: 64px;
    }
    .container {
      gap: 8rem;
    }
  `,
})
export class PaymentTypeComponent implements OnInit {
  inscriptionId = this.route.snapshot.params['inscriptionId'];

  pendingAmount = 0;
  loading = true;
  constructor(
    private route: ActivatedRoute,
    private inscriptionService: InscriptionService,
    private tpvService: TPVService,
    public navController: NavController,
  ) {}

  async ngOnInit() {
    const inscriptionData = await this.inscriptionService.getInscriptionTotal(this.inscriptionId);
    this.pendingAmount = inscriptionData.pendingAmount;
    this.loading = false;
  }

  doPayment() {
    if (this.loading) return;
    this.loading = true;
    this.tpvService
      .createRedsysPaymentIntent(this.inscriptionId)
      .catch((error) => {
        console.error('Error creating payment intent', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
